import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { IntlProvider } from "react-intl-redux";

import AirbrakeProvider from './components/AirbrakeProvider';
import ErrorBoundary from './components/ErrorBoundary';
import App from './components/App';

const renderSelfRegistration = ({ store, airbrake }) => {
  ReactDOM.render(
    <React.StrictMode>
      <AirbrakeProvider airbrake={airbrake}>
        <ErrorBoundary>
          <Provider store={store}>
            <IntlProvider>
              <App />
            </IntlProvider>
          </Provider>
        </ErrorBoundary>
      </AirbrakeProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
};

export default renderSelfRegistration;
